import cx from 'classnames';

import usePullToRefresh, { PULL_THRESHOLD } from '../../../hooks/usePullToRefresh';
import LoadingDots from '../LoadingDots';
import { ReactComponent as ArrowDownIcon } from '../../../icons/arrow-down.svg';

import './PullToRefresh.scss';

const SIZE = 40;

const PullToRefresh = () => {
  const { pull, refreshing } = usePullToRefresh();
  if (!pull && !refreshing) return null;

  const armed = refreshing || pull >= PULL_THRESHOLD;
  const offset = refreshing ? PULL_THRESHOLD : pull;

  return (
    <div
      className={cx('PullToRefresh', { armed, refreshing })}
      style={{
        transform: `translate(-50%, ${offset - SIZE}px)`,
        opacity: refreshing ? 1 : Math.min(pull / PULL_THRESHOLD, 1),
      }}
      aria-hidden="true"
    >
      {refreshing ? <LoadingDots width="1.6em" /> : <ArrowDownIcon className="arrow" />}
    </div>
  );
};

export default PullToRefresh;
